var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTickFilledBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66797C5.3988 1.66797 1.66797 5.3988 1.66797 10.0013C1.66797 14.6038 5.3988 18.3346 10.0013 18.3346C14.6038 18.3346 18.3346 14.6038 18.3346 10.0013C18.3346 5.3988 14.6038 1.66797 10.0013 1.66797ZM8.33464 14.513L4.41214 10.5905L5.59047 9.41214L8.33464 12.1563L14.4121 6.0788L15.5905 7.25714L8.33464 14.513Z",
    fill: "#1560D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTickFilledBlue);
export default __webpack_public_path__ + "static/media/ic_tick_filled_blue.4445c4365f6872042e4b4cd07dcb74de.svg";
export { ForwardRef as ReactComponent };